import React, { useContext, useEffect } from "react";
import { InstitutionalContext } from "../../context/InstitutionalContext";

function TermsOfUse() {
    const { institutionals, fetchInstitutional } = useContext(InstitutionalContext);
    
    useEffect(() => {
        const shippingCategory = "kullanim-kosullari";
        if (!institutionals?.sef || institutionals.sef !== shippingCategory) {
            fetchInstitutional(shippingCategory);
        }
    }, [institutionals?.sef, fetchInstitutional]);

    

    return ( 
        <> 
              <div className='tab-pane'>
                <h4>Kullanım Koşulları</h4>
                {institutionals?.aciklama ? (
                  <div dangerouslySetInnerHTML={{ __html: institutionals.aciklama }} />
                ) : (
                  <p>Yükleniyor...</p>
                )}
              </div>
        </>
     );
}

export default TermsOfUse;